//アコーディオンに必要なclassの付け替え

export function accordionMove() {

	const images = document.querySelectorAll('.p-accordion__iconImage');

	images.forEach(image => {
		image.addEventListener('click', () => {
			image.closest('.p-accordion').classList.toggle('is-appear');
			//dtにはクリックされたdt要素、elには全てのdtが入る
			images.forEach(el => {
				if (image !== el) {
					el.closest('.p-accordion').classList.remove('is-appear');
				}
			});
		});
	})

}
